import api from "./api";
import merchantToken from "./merchant.token";

const SERVICE_URL = "customer-service/customer";

export default {
  getCities(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}/cities`,
        {
          province: payload
        },
        {
          "X-Merchant-Token": merchantToken.merchantToken()
        }
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  getProvinces() {
    return new Promise((resolve, reject) => {
      api.get(
        `${SERVICE_URL}/provinces`,
        {
          "X-Merchant-Token": merchantToken.merchantToken()
        }
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  }
};
